import store from "@/store";

export function getToken() {
  return store.state.token;
}

export function hasSession() {
  return Boolean(store.state.token && store.state.userInfo);
}

export function removeToken() {
  store.dispatch("removeLoginInfo");
}
